import { render, staticRenderFns } from "./CustomRadio.vue?vue&type=template&id=2990fdc3&scoped=true&"
import script from "./CustomRadio.vue?vue&type=script&lang=js&"
export * from "./CustomRadio.vue?vue&type=script&lang=js&"
import style0 from "./CustomRadio.vue?vue&type=style&index=0&id=2990fdc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990fdc3",
  null
  
)

export default component.exports